<div fes-table-view-default-cell-renderer [column]="column" [record]="record"
[tableComponent]="tableComponent">
</div>

